export default [
  {
    path: '/uuidUpgrade',
    component: () => import('@/views/ota/uuidUpgrade.vue'),
    name: 'upgrade',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/uuidUpgrade2',
    // component: () => import('@/views/ota/uuidUpgrade2.vue'),
    name: 'upgrade2',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
    redirect: (to) => {
      const vinNo = to.query.id || to.query.vinNo;
      return { name: 'ota-instrument-upgrade', params: { vinNo } };
    },
  },
  {
    path: '/uuidInstru',
    component: () => import('@/views/ota/uuidInstru.vue'),
    name: 'uuidInstru',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/upgrade/:vinNo',
    component: () => import('@/views/ota/instrument/Upgrade.vue'),
    name: 'ota-instrument-upgrade',
    meta: {
      title: 'OTA',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/question/:vinNo',
    component: () => import('@/views/ota/instrument/Question.vue'),
    name: 'ota-instrument-question',
    meta: {
      title: '升级问题',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/connect/:vinNo',
    component: () => import('@/views/ota/instrument/Connect.vue'),
    name: 'ota-instrument-connect',
    meta: {
      title: '连接热点',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/assistant/:vinNo',
    component: () => import('@/views/ota/instrument/Assistant.vue'),
    name: 'ota-instrument-assistant',
    meta: {
      title: '升级助手',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/ota/instrument/accCruiseInstruction',
    component: () => import('@/views/ota/instrument/AccCruiseInstruction.vue'),
    name: 'ota-instrument-AccCruiseInstruction',
    meta: {
      title: 'ACC自适应巡航功能说明',
      backgroundClass: 'bg-gray',
    },
  },
];
